<template>
  <div class="history-container">
    <PageHeader showBack showBreadcrumb @back="$router.push({ name: 'Lower' })"></PageHeader>
    <CardContainer class="container" padding="0">
      <Empty class="hl-empty" :imgSize="160" v-if="list.length === 0" />
      <div class="container-wrap" v-else>
        <div class="wrap-box">
          <div class="version-div" v-for="(item, index) in list" :key="index">
            <div class="flag" :class="{ new: index === 0 }">
              <span v-if="index === 0">New</span>
            </div>
            <div class="line" :class="{ double: index % 2 === 0 }"></div>
            <div class="time" :class="{ new: index === 0 }">
              <div class="month-day">{{ getTime(item.createTime, 'MM月DD日') }}</div>
              <div class="year">{{ getTime(item.createTime, 'YYYY') }}</div>
            </div>
            <div class="content">
              <div class="version">{{ item.version | format }}</div>
              <div class="remark">{{ item.remark | format }}</div>
            </div>
          </div>
        </div>
      </div>
    </CardContainer>
  </div>
</template>

<script>
import Empty from '@/components/Empty'
import { formatTime, format } from '@/utils/utils'
export default {
  name: 'LowerHistory',
  components: {
    Empty
  },
  filters: {
    format
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    // 历史记录列表
    let params = {
      firmwareType: 'LOWER'
    }
    this.$ajax.get(this.$api.fota.firmware_version_history, params).then((res) => {
      this.list = res.data
    })
  },
  methods: {
    getTime(val, format) {
      return formatTime(val, format)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-container {
  height: 100%;
  .container {
    min-height: calc(100% - 57px);
    background-image: url('../../../assets/version_distribution_bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /deep/ .el-card__body {
      height: 100%;
      .hl-empty {
        margin: 200px auto;
      }
      .container-wrap {
        padding-left: 153px;
        width: 100%;
        height: 100%;
        .wrap-box {
          padding: 24px 0;
          width: 100%;
          height: 100%;
          border-left: 2px solid #e9eaeb;
          .version-div {
            margin-top: 40px;
            height: 132px;
            &:first-child {
              margin-top: 0;
            }
            .flag {
              display: inline-block;
              margin-left: -9px;
              width: 17px;
              height: 17px;
              background: #ffffff;
              border: 3px solid #339dff;
              border-radius: 50%;
              vertical-align: middle;
              &.new {
                margin-left: -24px;
                width: 48px;
                height: 48px;
                line-height: 42px;
                font-size: 18px;
                font-weight: 600;
                color: #2ba5f7;
                text-align: center;
              }
            }
            .line {
              display: inline-block;
              width: 74px;
              height: 2px;
              background-color: #bae7ff;
              vertical-align: middle;
              &.double {
                width: 190px;
              }
            }
            .time {
              display: inline-block;
              margin-right: 24px;
              padding-top: 36px;
              width: 132px;
              height: 132px;
              background: #ffffff;
              border: 3px solid #00cbd3;
              box-shadow: 0px 10px 20px 0px rgba(34, 42, 57, 0.08);
              border-radius: 50%;
              vertical-align: middle;
              .month-day {
                line-height: 34px;
                font-size: 26px;
                font-weight: 600;
                color: #333333;
                text-align: center;
              }
              .year {
                line-height: 26px;
                font-size: 18px;
                font-weight: 600;
                color: #999999;
                text-align: center;
              }
              &.new {
                border: none;
                background-image: linear-gradient(-26deg, #00dbe5 0%, #339dff 100%);
                box-shadow: 0px 10px 20px 0px rgba(34, 42, 57, 0.08);
                .month-day {
                  color: #ffffff;
                }
                .year {
                  color: #b1eeff;
                }
              }
            }
            .content {
              display: inline-block;
              vertical-align: middle;
              .version {
                line-height: 28px;
                font-size: 20px;
                font-weight: 600;
                color: #333333;
              }
              .remark {
                line-height: 22px;
                font-size: 14px;
                color: #666666;
              }
            }
          }
        }
      }
    }
  }
}
</style>
